module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"comments":"Comments"},"fr":{"comment":"Commentaires"},"de":{"comment":"Kommentare"}}')
  delete Component.options._Ctor
}
